<template>
  <div>
    <h2>Attendee email notifications settings</h2>
    <v-layout row>
      <v-flex xs9>
        <v-expansion-panel focusable>
          <v-expansion-panel-content v-for="(item, index) in notificationSettings" :key="index">
            <div slot="header">{{item.notificationKey}}</div>
            <v-card>
              <v-card-text>
                <v-switch
                  :label="item.isEnabled? 'Enabled': 'Disabled'"
                  v-model="item.isEnabled"
                ></v-switch>

                <v-layout row>
                  <v-flex xs5>
                    <v-select
                      :items="attendeeNotificationsTemplatesList"
                      v-model="item.emailTemplateKey"
                      label="Select email template"
                      item-text="templateKey"
                      item-value="templateKey"
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>

                <v-btn @click="submitChanges(item)">submit</v-btn>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { clone, isEmpty, isNil } from 'ramda'
import mixins from '@/utils/mixins'

const HIDDEN_NOTIFICATIONS_KEY = ['Status.RequestForPayment', 'RequestForPayment']

export default {
  name: 'attendee-notifications-settings',
  mixins: [mixins.emailTemplates],
  data () {
    return {
      notificationSettings: null,
    }
  },
  computed: {
    ...mapGetters(['getAttendeeSettings'])
  },
  watch: {
    getAttendeeSettings: {
      handler (newVal) {
        if (!isEmpty(newVal) && !isNil(newVal)) {
          this.notificationSettings = clone(newVal).filter(notification => {
            return !HIDDEN_NOTIFICATIONS_KEY.includes(notification.notificationKey)
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['fetchAttendeeSettings', 'updateAttendeeSettings']),
    async requestData () {
      await this.fetchAttendeeSettings()
    },
    submitChanges (item) {
      this.updateAttendeeSettings(item)
    }
  },
  created () {
    this.requestData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/EmailNotificationsSettings/AttendeeNotificationsSettings/index.vue